const tabsJS = {
  init () {
    if ($('.tabs').length) {
      // $('.slick-slider').slick('refresh');
      $(document).foundation();
      Foundation.reInit('equalizer');
      $('.slick-slider').slick('refresh');
      $('.tabs').on('change.zf.tabs', function() {
        $(document).foundation();
        Foundation.reInit('equalizer');
        $('.slick-slider').slick('refresh');
      });

      $('.single-listing-tabs').on('change.zf.tabs', function(e, tab) {
        let tabHref = $(tab).find('.o-tabs__title-link').attr('href');

        let targetClass = tabHref.substring(1,tabHref.length);

        // if ( targetClass == "location" ) {
        //   if ( !$('body').hasClass('single-listing-' + targetClass) ) {
        //     $('body').addClass('single-listing-' + targetClass);
        //   }
        // } else {
        //   $('body').removeClass('single-listing-location');
        // }
      });
    }
  }
};
export default tabsJS;



// WEBPACK FOOTER //
// ./src/components/03-ui/37-listing-tabs/37-listing-tabs.js